import { Location } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { Router } from '@angular/router';
import { UpdatePageConfigStyle } from '@app/finxone-web-frontend/app/lib/actions/page-context.action';
import { NavigationService } from '@app/finxone-web-frontend/app/lib/services/navigation-service/navigation.service';
import { WorkflowFormGuard } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-form.guard';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { scrollAndUpdateFragment } from '@app/finxone-web-frontend/app/lib/utils/form-widget-action-utils/input-widget-verify-button-action.utils';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { PageConfigurationProvider } from '../../../zones/page-configuration.provider';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss'],
})
export class QuickLinksComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() quickLinksData: {
    title: string;
    url: string | undefined;
    pageId: string | undefined;
    icon: string | undefined;
    role: string | undefined;
    zone: string | undefined;
    browserBehaviour: string | undefined | null;
    externalLink: string | undefined | null;
  };
  @Input() contentStyle: baseCssConfigStyle;
  @Input() textContentStyle: baseCssConfigStyle;
  @Input() public iconStyle?: baseCssConfigStyle;
  @Input() globalStylingClass = '';
  @Input() isAllowedGlobalStyling = false;
  public readonly activationDelaySeconds = input<number>();

  @Select(RoleState.getRole)
  roles!: Observable<RoleStateModel>;
  roleInfo: RoleStateModel;

  constructor(
    private _router: Router,
    private store: Store,
    public pageConfig: PageConfigurationProvider,
    private location: Location,
    private navigationService: NavigationService,
  ) {
    this.roles.pipe(takeUntil(this.destroy$)).subscribe((roles) => {
      this.roleInfo = roles;
    });
  }

  get buttonStyles() {
    return this.isAllowedGlobalStyling ? {} : { ...this.textContentStyle, ...this.contentStyle };
  }

  goToLink(url: string | undefined, role: string | undefined) {
    // Disable form validation check for navigation
    WorkflowFormGuard.disableFormValidation();

    this.navigationService
      .navigateByPageUrl({
        url,
        targetRole: role,
        currentRole: this.roleInfo.role,
        zone: this.quickLinksData.zone,
        externalLink: this.quickLinksData.externalLink,
        browserBehaviour: this.quickLinksData.browserBehaviour,
      })
      .then((navigated) => {
        if (!navigated) {
          return;
        }

        if (!url?.includes('/zones/login')) {
          scrollAndUpdateFragment(this._router);
          this.dispatchPageConfigStyleAction();
        }
      });
  }

  private dispatchPageConfigStyleAction() {
    const isCurrentPathModal = this.location.path().includes('modal:');
    if (isCurrentPathModal) {
      this.store.dispatch(new UpdatePageConfigStyle());
    }
  }
}
